import { DropdownPaginated } from "components/commons";
import React, { useCallback } from "react";
import { getStations } from "apis";
import { useApi } from "hooks";
import { locale } from "localization/en";

const SelectRedemptionStation = ({
  placeholder = "",
  disableAllOption,
  params,
  showStationCode = false,
  ...props
}) => {
  const stationParams = {
    ...params,
  };
  const {
    request,
    loading,
    result = { stations: [], count: 0 },
  } = useApi({
    api: getStations,
    params: stationParams,
    pageError: true,
  });

  const fetch = useCallback(
    async (params) => {
      return await request({
        perPage: 1000,
        page: 1,
        ...params,
      });
    },
    [request]
  );

  return (
    <DropdownPaginated
      isMultiple
      {...props}
      request={async (params) => {
        return await fetch(params);
      }}
      total={result.count}
      loading={loading}
      allSelectedText={locale.allRedemptionStations}
      allLabel={props.value.length === 1 ? props.value[0].label : locale.redemptionStations}
      selectAllLabel={locale.selectAll}
      formatRequest={(result) => {
        const { stations = [] } = result || {};
        if (stations && stations.length > 0) {
          const newStations = stations;

          return newStations.map((d) => {
            return {
              label: showStationCode && d.stationCode ? `${d.stationCode} ${d.name}` : d.name,
              value: d.stationId,
              stationProduct: d.stationProduct,
              createdAt: d.createdAt,
              stationCode: d.stationCode,
            };
          });
        }
        return [];
      }}
      placeholder={placeholder}
      {...(!disableAllOption
        ? {
            allOption: [
              {
                label: "All",
                value: null,
              },
            ],
          }
        : [])}
    />
  );
};

export default SelectRedemptionStation;
